define('core/Form',['underscore', 'knockout'], function(_, ko) {

    function Form(submitCallback) {

        var self = this;

        self.fields = ko.observableArray();

        self.submitCallback = submitCallback;

        /**
         * Indicates whether it is waiting on a submit promise
         */
        self.isSubmitting = ko.observable(false);

        /**
         * Indicates whether the form is ready to be submit
         *
         * Using isGood instead of hasPassed to test for readiness as this is
         * more convenient for forms split over multiple steps. Can't foresee
         * issues with it at this time.
         */
        self.submitIsDisabled = ko.pureComputed(function() {
            return self.isSubmitting() || _.some(self.fields(), function(field) { return !field.isGood(); });
        });

        self.isBusy = ko.pureComputed(function() {
            return _.some(self.fields(), function(field) { return field.isValidating(); });
        });

    }

    Form.prototype.attachField = function(field) {
        field.attachToForm(this);
        this.fields.push(field);
    };

    Form.prototype.detachField = function(field) {
        field.detachFromForm();
        this.fields.remove(field);
    };

    Form.prototype.submit = function() {

        var self = this,
            optionalPromise = self.submitCallback();

        if (!optionalPromise) {
            return;
        }

        self.isSubmitting(true);

        optionalPromise.finally(function() {
            self.isSubmitting(false);
        });
    };

    return Form;

});

